var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.519,
    height: 18.538,
    viewBox: "0 0 34.519 18.538"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.708)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 33.105,
    transform: "translate(0 8.562)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9,17.823l8.562-8.562L55.9.7",
    transform: "translate(-31.357 -0.7)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNC41MTkiIGhlaWdodD0iMTguNTM4IiB2aWV3Qm94PSIwIDAgMzQuNTE5IDE4LjUzOCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjcwOCkiPjxsaW5lIHgyPSIzMy4xMDUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgOC41NjIpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIi8+PHBhdGggZD0iTTU1LjksMTcuODIzbDguNTYyLTguNTYyTDU1LjkuNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMxLjM1NyAtMC43KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMiIvPjwvZz48L3N2Zz4=";
export { SvgLinkArrow as ReactComponent };